import React from 'react';
import styles from './ImportGameForm.module.scss';
import { Form } from '../../../components';
import { useStore } from '../../../../common';

const BulkAssignPartnersForm = (): JSX.Element => {
	const [state] = useStore();
	const { bulkAssignPartnersForm, success, infoText, formErrors } = state;
	const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (event.target.files && event.target.files.length > 0) {
			bulkAssignPartnersForm.file = event.target.files[0];
		}
	};

	const downloadFile = process.env.REACT_APP_SITE_TITLE?.includes('Italy')
		? 'assign_partners_it_example.csv'
		: 'assign_partners_example.csv';

	return (
		<section>
			<Form success={success}>
				<div className={styles.CreateGameForm}>
					<input type='file' onChange={handleFileChange} className={styles.input} placeholder='Add file' />
				</div>
				{formErrors && !!Object.keys(formErrors).length && (
					<div style={{ marginTop: 10, color: 'red' }}>
						{Object.values(formErrors).map((message, i) => (
							<p key={i}>{message}</p>
						))}
					</div>
				)}
				<p className={styles.note}>After the import, a report will be sent to your email.</p>
				{infoText?.error?.map((errorObj: any, i: number) =>
					Object.entries(errorObj).map(([gameIndex, messages]) => (
						<div key={`${i}-${gameIndex}`} style={{ marginTop: '10px', color: 'red' }}>
							<p>
								<strong>Line {gameIndex}:</strong>
							</p>
							<ul style={{ margin: 0, paddingLeft: '1em' }}>
								{(messages as string[]).map((msg, j) => (
									<li key={j}>{msg}</li>
								))}
							</ul>
						</div>
					))
				)}
				<a href={`${process.env.REACT_APP_BASE_URL}/common/${downloadFile}`} download={downloadFile}>
					Download Example
				</a>
			</Form>
		</section>
	);
};

export { BulkAssignPartnersForm };
